import React, {
  useEffect,
  useContext,
  Fragment,
  useReducer,
  createContext,
} from 'react';
import { useParams } from 'react-router-dom';
import { store as mainStore } from '../../../../../store';
import Loading from '../../../../../components/OtherElements/Loading';
import AccessDenied from '../../../../../components/OtherElements/AccessDenied';
import { actionList } from '../../../../../config';
import { initialState, reducer, actions } from './reducer';
import FullContent from './FullContent';
import FullCard from '../../../../../components/Card/FullCard';
import ListDrivers from './ListDrivers';
import ListBidders from './ListBidders';
import Accordion from '../../../../../components/Accordion/Accordion';
import { makeStyles } from '@material-ui/core/styles';
import { useSearchParams } from 'hooks/useSearchParams';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

export const store = createContext(null);
const { Provider } = store;
const Tendering = () => {
  useTitle('مناقصه');
  const classes = useStyles();
  const accessName = 'tendering';
  const { state: mainState, dispatch: mainDispatch, showError } = useContext(
    mainStore
  );
  const { itemsCountPerPage } = mainState.Props;
  const { id } = useParams();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { driversPage, biddersPage } = state;
  const { order } = state;
  const [params, setParams] = useSearchParams();

  const logout = () => {
    showError('عدم رعایت سیکل سفارش. دسترسی غیرقانونی شناسایی شد.');
    mainDispatch({ type: 'AUTH', action: 'LOGOUT' });
  };
  const fetchOrder = async () => {
    try {
      const order = await actions.fetchingOrder(id);
      dispatch({ type: 'ORDER', payload: order });
    } catch (error) {
      showError(error);
    }
  };
  const fetchCommissions = async () => {
    try {
      const data = await actions.calculatingCommissions(id);
      if (data?.ok) {
        dispatch({ type: 'COMMISSIONS', payload: data.commissions });
      }
    } catch (error) {
      showError(error);
    }
  };
  const fetchingDrivers = async () => {
    try {
      const drivers = await actions.fetchingDrivers(order._id);
      dispatch({ type: 'DRIVERS', payload: drivers });
    } catch (error) {
      showError(error);
    }
  };
  const fetchingBidders = async () => {
    try {
      const bidders = await actions.fetchingBidders(
        order._id,
        biddersPage,
        itemsCountPerPage
      );
      dispatch({ type: 'BIDDERS', payload: bidders });
    } catch (error) {
      showError(error);
    }
  };
  const refresh = () => {
    fetchOrder();
    fetchCommissions();
    fetchingDrivers();
    fetchingBidders();
  };

  const asyncRefresh = async () => {
    await fetchOrder();
    await fetchCommissions();
    await fetchingDrivers();
    await fetchingBidders();
  };

  useEffect(() => {
    fetchOrder();
    fetchCommissions();
  }, []);
  useEffect(() => {
    order && !actionList[order.status].includes(accessName) && logout();
  }, [order]);

  return (
    <Provider value={{ state, dispatch, actions, refresh, asyncRefresh }}>
      {order ? (
        <Fragment>
          {actionList[order.status].includes(accessName) ? (
            <FullCard title="مناقصه">
              <div className={classes.root}>
                <FullContent />
                {order.status !== 'tendering' && (
                  <div className="mt-3">
                    برای مشاهده ی رانندگان و پیشنهاد رانندگان وضعیت سفارش باید
                    "در حال مناقصه" باشد
                  </div>
                )}
                {order.status === 'tendering' && (
                  <>
                    <Accordion open={false} title="پیشنهادات رانندگان">
                      <ListBidders />
                    </Accordion>
                    <Accordion open={true} title="رانندگان">
                      <ListDrivers />
                    </Accordion>
                  </>
                )}
              </div>
            </FullCard>
          ) : (
            // <HalfCards
            //   fullContent={}
            //   title="مناقصه"
            //   title2="لیست رانندگان"
            //   category2="لیست رانندگان جهت انتخاب برای سفارش"
            //   content2={<ListDrivers />}
            //   title1="لیست پیشنهادات رانندگان"
            //   category1="یک یا چند راننده را انتخاب و برای صاحب بار ارسال کنید"
            //   content1={<ListBidders />}
            // />
            <AccessDenied />
          )}
        </Fragment>
      ) : (
        <Loading text="درحال بررسی سفارش ..." />
      )}
    </Provider>
  );
};

export default Tendering;
